import * as angular from 'angular';

import { IDispatcherService, IDispatcher, TemplateCreationProperties } from '../';
import { ITemplateActionsService } from './templates.actionCreator';
import { Template } from '../../models';

export interface ITemplatesStoreService {
    getOne(guid: string): angular.IPromise<Template>;
    getAll(): angular.IPromise<Template[]>;
    getAll(force: boolean): angular.IPromise<Template[]>;
    create(target: TemplateCreationProperties): angular.IPromise<Template>;
    deleteOne(guid: string): angular.IPromise<Template[]>;
}

export interface ITemplatesActionDispatcherService extends IDispatcherService<ITemplatesStoreService> { }

export class TemplatesActionDispatcherService implements ITemplatesActionDispatcherService {
    static serviceId = 'templatesActionDispatcherService';

    static $inject = ['templateActionsService'];

    constructor(private _actionService: ITemplateActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITemplatesStoreService> {
        const as = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(as.getOne(guid)),
                getAll: (force?: boolean) => dispatch(as.getAll(force)),
                create: (target: TemplateCreationProperties) => dispatch(as.create(target)),
                deleteOne: (guid: string) => dispatch(as.deleteOne(guid)),
            }
        };
    }
}